















import { Component, Vue } from 'vue-property-decorator';
import { tokenModule } from '@/store/authentication/authentication';

@Component
export default class Expire extends Vue {

  public created(): void {
    tokenModule.削除する();
  }
}
